import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/BellonaYatak.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const WeltewYatak = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
  
    useEffect(() => {
      // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
      if (window.location.hash) {
        const element = document.getElementById(window.location.hash.substring(1));
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      }
    }, []);

      const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

  const closeDetail = () => {
    setIsDetailOpen(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

    // Ürün bilgileri
  const products = {
    'thermalist-yatak': {
      name: 'Thermalist Yatak, Baza ve Başlık Seti',
      image: '../files/thermalist-yatak.jpg',
      description: 'Çift yönlü kullanım özelliği ile bir tarafı yazın sizi serin tutarken diğer tarafı kışın vücudunuzu sıcak tutarak rahat uyku uyumanızı sağlar.',
      features: [
        'Çift Yönlü Kullanım Özelliği',
        'Yaz/Kış Termostat Kontrolü',
        'Kuş Tüyü Omurga Destek Süngeri',
        'Paket Yay Teknolojisi',
        'Vücut Basıncı Dengeleyici',
        'Jakarlı Silinebilir Kumaş',
        'Isı ve Basınç Ayarlayıcı'
      ],
      dimensions: 'Çeşitli Boyut Seçenekleri',
      material: 'Memory Foam + Kuş Tüyü Sünger',
      warranty: '2 Yıl Garanti',
      price: "21.340,00 ₺'den başlayan fiyatlarla",
    },
    'monaco-yatak': {
      name: 'Monaco Yatak, Baza ve Başlık Seti',
      image: '../files/monaco-yatak.webp',
      description: 'Bağımsız paket yay sistemi ile vücut basıncını eşit dağıtan Monaco yatak.',
      features: [
        'Bağımsız Paket Yay Sistemi',
        'Çift Sertlik Seçeneği',
        'Omurga Pozisyon Desteği',
        'Hareket İzolasyonu',
        'EcoVero Kumaş',
        'Ekstra Havalandırma',
      ],
      dimensions: 'Çeşitli Boyut Seçenekleri',
      material: 'Bağımsız Paket Yay + EcoVero Kumaş',
      warranty: '1 Yıl Garanti',
      price: "36.027,00 ₺'den başlayan fiyatlarla",
    },
    'bohem-yatak': {
      name: 'Bohem Yatak, Baza ve Başlık Seti',
      image: '../files/bohem-yatak.webp',
      description: 'Zeytinyağlı apre ile özel olarak geliştirilmiş yatak üst kumaşı, cildinize dost, nefes alabilir ve yumuşacık bir uyku deneyimi sunar. Bağımsız paket yay sistemi ile vücut basıncını eşit dağıtır.',
      features: [
        'Zeytinyağlı Apre Kumaş',
        'Yumuşak Sert Yüzey',
        'Bağımsız Paket Yay',
        'Ses İzolasyonu',
        'Omurga Desteği',
        'Robot Süpürge Uyumlu',
        'Emniyet Kilitli Amortisör'
      ],
      dimensions: 'Çeşitli Boyut Seçenekleri',
      material: 'Zeytinyağlı Apre Kumaş',
      warranty: '2 Yıl Garanti',
      price: "33.372,00 ₺'den başlayan fiyatlarla",
    }
  };

  return (
    <div className="weltew-yatak">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/weltew-logo.png" alt="Weltew Yatak Logo" />
            </div>
            <h1>Weltew Yatak Koleksiyonu</h1>
            <p>Kaliteli uyku ve konfor için premium yatak çözümleri</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Yatak Kategorilerimiz</h2>

            {/* Yatak, Baza, Başlık Setleri */}
            <div className="category-section" id="yatak">
              <h3 className="category-title">🛏️ Yatak, Baza, Başlık Setleri</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/thermalist-yatak.jpg" alt="Yataş Thermalist Yatak 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('thermalist-yatak')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Thermalist Yatak, Baza ve Başlık Seti</h4>
                    <p>Çift yönlü kullanım ile yaz/kış konfor teknolojisi</p>
                    <div className="product-features">
                      <span className="feature">✓ Çift Yönlü Kullanım</span>
                      <span className="feature">✓ Kuş Tüyü Desteği</span>
                      <span className="feature">✓ Paket Yay Sistemi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">21.340,00 ₺</span>
                    </div>

                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/monaco-yatak.webp" alt="Monaco Yatak" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('monaco-yatak')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Monaco Yatak, Baza ve Başlık Seti</h4>
                    <p>Bağımsız paket yay ve çift sertlik seçeneği</p>
                    <div className="product-features">
                      <span className="feature">✓ Paket Yay Sistemi</span>
                      <span className="feature">✓ Çift Sertlik</span>
                      <span className="feature">✓ EcoVero Kumaş</span>
                    </div>
                    <div className="product-price">
                      <span className="price">36.027,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/bohem-yatak.webp" alt="Bohem Yatak" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('bohem-yatak')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Bohem Yatak, Baza ve Başlık Seti</h4>
                    <p>Zeytinyağlı apre kumaş ile doğal konfor teknolojisi</p>
                    <div className="product-features">
                      <span className="feature">✓ Zeytinyağlı Apre</span>
                      <span className="feature">✓ Paket Yay Sistemi</span>
                      <span className="feature">✓ Metal Konstrüksiyon</span>
                    </div>
                    <div className="product-price">
                      <span className="price">33.372,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Yataş Yatak Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h3>60 Yıllık Deneyim</h3>
                <p>Türkiye'nin en köklü yatak markası</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔬</div>
                <h3>Ar-Ge Merkezi</h3>
                <p>Sürekli araştırma ve geliştirme</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌿</div>
                <h3>Doğal Malzemeler</h3>
                <p>Çevre dostu ve sağlıklı malzemeler</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💤</div>
                <h3>Uyku Uzmanı</h3>
                <p>Kaliteli uyku için bilimsel yaklaşım</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Yataş Yatak ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>

              {/* Product Detail Modal */}
              {isDetailOpen && selectedProduct && products[selectedProduct] && (
                <div className="product-detail-modal">
                  <div className="modal-overlay" onClick={closeDetail}></div>
                  <div className="modal-content">
                    <button className="close-button" onClick={closeDetail}>
                      <FaTimes />
                    </button>
                    
                    <div className="modal-body">
                      <div className="product-image-section">
                        <img 
                          src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                          alt={products[selectedProduct]?.name || 'Ürün'}
                          className="detail-image"
                        />
                      </div>
                      
                      <div className="product-info-section">
                        <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                        <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                        
                        <div className="product-details">
                          <h3>Özellikler</h3>
                          <ul className="features-list">
                            {(products[selectedProduct]?.features || []).map((feature, index) => (
                              <li key={index}>✓ {feature}</li>
                            ))}
                          </ul>
                          
                          <div className="specifications">
                            <h3>Teknik Özellikler</h3>
                            <div className="spec-item">
                              <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                            </div>
                            <div className="spec-item">
                              <strong>Malzeme:</strong> {products[selectedProduct]?.material || 'Belirtilmemiş'}
                            </div>
                            <div className="spec-item">
                              <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                            </div>
                            <div className="spec-item price">
                              <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                            </div>
                          </div>
                          
                          <div className="action-buttons">
                            <a href="tel:+905496250335" className="btn btn-primary">
                              📞 Fiyat Bilgisi Al
                            </a>
                            <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                              <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                              WhatsApp
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
        
      </main>

      <Footer />
    </div>
  );
};

export default WeltewYatak;
